import s from './scss/gemComponentsView.scss';
import GemInteriorView from './gemInteriorView/GemInteriorView';
import cn from 'classnames';

const GemComponentsView = ({
  className,
  vh,
  vw
}) => {

  const faktor = vw <= 678 ? 2.5 : 1.5;

  return (
    <div className={cn(className, s.wrapper)}>
      <GemInteriorView
        size={vh / faktor}
      />
    </div>
  );
};

export default GemComponentsView;



// WEBPACK FOOTER //
// ./components/gemView/gemComponentsView/GemComponentsView.js